import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
  Tabs,
  Textarea,
  Table,
  CollectionPreferences,
  TextFilter,
  Pagination,
  SegmentedControl,
} from "@cloudscape-design/components";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { link } from "fs";


export default function Results() {
  const { 
    activeSeriesName, setActiveSeriesName
  } = useContext(GlobalContext);
  const [value, setValue] = useState("");
  const [selectedItems, setSelectedItems] = useState([{
    position: "1",
    driver: "Lewis Hamilton",
    carNum: "1",
    iRating: "10000",
    lapTime: "1:22.003",
  }]);

  const resultsTable = () => {
    return (
      <>
        <Table
          onSelectionChange={({ detail }) =>
            setSelectedItems(detail.selectedItems)
          }
          selectedItems={selectedItems}
          columnDefinitions={[
            {
              id: "position",
              header: "Position",
              cell: e => e.position,
              sortingField: "position",
              // isRowHeader: true,
            },
            {
              id: "driver",
              header: "Driver",
              cell: e => e.driver,
              sortingField: "driver"
            },
            {
              id: "carNum",
              header: "Car #",
              cell: e => e.carNum
            },
            {
              id: "iRating",
              header: "iRating",
              cell: e => e.iRating
            },
            {
              id: "lapTime",
              header: "Lap Time",
              cell: e => e.lapTime
            }
          ]}
          // columnDisplay={[
          //   { id: "position", visible: true },
          //   { id: "driver", visible: true },
          //   { id: "carNum", visible: true },
          //   { id: "iRating", visible: true },
          //   { id: "lapTime", visible: true }
          // ]}
          items={[
            {
              position: "1",
              driver: "Tai Ratcliff 1",
              carNum: "01",
              iRating: "10000",
              lapTime: "1:22.553"
            },
            {
              position: "2",
              driver: "Tai Ratcliff 2",
              carNum: "02",
              iRating: "10000",
              lapTime: "1:22.553"
            },
            {
              position: "3",
              driver: "Tai Ratcliff 3",
              carNum: "03",
              iRating: "10000",
              lapTime: "1:22.553"
            },
            {
              position: "4",
              driver: "Tai Ratcliff 4",
              carNum: "04",
              iRating: "10000",
              lapTime: "1:22.553"
            },
            {
              position: "5",
              driver: "Tai Ratcliff 5",
              carNum: "05",
              iRating: "10000",
              lapTime: "1:22.553"
            }
          ]}
          loadingText="Loading resources"
          resizableColumns
          // sortingColumn={{position: "asc"}}
          // selectionType="multi"
          totalItemsCount={40}
          stickyHeader
          trackBy="position"
          empty={
            <Box textAlign="center" color="inherit">
              <b>No resources</b>
              <Box
                padding={{ bottom: "s" }}
                variant="p"
                color="inherit"
              >
                No resources to display.
              </Box>
              <Button>Create resource</Button>
            </Box>
          }
          filter={
            <TextFilter
              filteringPlaceholder="Find resources"
              filteringText=""
            />
          }
          pagination={
            <Pagination
              currentPageIndex={1}
              pagesCount={3}
              ariaLabels={{
                nextPageLabel: "Next page",
                previousPageLabel: "Previous page",
                pageLabel: pageNumber =>
                  `Page ${pageNumber} of all pages`
              }}
            />
          }
          preferences={
            <CollectionPreferences
              title="Preferences"
              confirmLabel="Confirm"
              cancelLabel="Cancel"
              preferences={{
                pageSize: 40,
              }}
            />
          }
        />
      </>
    )
  }

  return (
    <>
      <SpaceBetween  size="xxl"  direction="horizontal">
        <Box>
          <div className="results-table-header" >
            <center><h1> {`${activeSeriesName} Championship Results`} </h1></center>
          </div>
          <Tabs
            tabs={[
              {
                label: "Drivers Championship",
                id: "drivers",
                content: resultsTable(),
                disabled: false,
              },{
                label: "Teams Championship",
                id: "teams",
                content: resultsTable(),
                disabled: false,
              }
            ]}
          />
        </Box>
        <Box>
          <div className="results-table-header">
            <center><h1> {`${activeSeriesName} Race Results`} </h1></center>
          </div>
          <Tabs
            tabs={[
              {
                label: "Pre Qualifying",
                id: "prequaly",
                content: resultsTable(),
                disabled: false,
              },{
                label: "Qualifying",
                id: "qualifying",
                content: resultsTable(),
                disabled: false,
              },{
                label: "Sprint Race",
                id: "spring",
                content: resultsTable(),
                disabled: false,
              },{
                label: "Feature Race",
                id: "feature",
                content: resultsTable(),
                disabled: false,
              }
            ]}
          />
        </Box>
      </SpaceBetween>
    </>
  )
}
